module.exports = __webpack_public_path__ + "img/profile-pic.49fd0d10.png";